import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import { HotToastRef } from '@ngxpert/hot-toast';
import { DataToastType } from './toast.interface';
@Component({
  selector: 'mts-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: false,
})
export class ToastComponent implements OnInit, AfterViewInit {
  constructor(
    @Optional()
    @Inject(HotToastRef)
    public toastRef: HotToastRef<DataToastType>,
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit() {}

  setNumberSite() {}

  toggleMobileMenu() {}
}
